export enum ConnectStatus {
  CONNECTING,
  CLOSED,
  CONNECTED,
  FAILED,
}

export enum UploadType {
  FileAndFolder = 0,
  Folder,
}
